<template>
    <div>
        <el-table class="o-table" :data="tableData" :show-header="ifShowHeader">
            <div slot="empty">
                <span>您还没有相关订单</span>
            </div>
            <el-table-column>
                <template slot-scope="scope">
                    <el-row class="title-row" type="flex">
                        <el-col :span="6">
                            <span>下单时间：</span><span>{{scope.row.orderTime}}</span>
                        </el-col>
                        <el-col :span="6">
                            <span>订单编号：</span><span>{{scope.row.appNo}}</span>
                        </el-col>
                        <el-col :span="3" style="text-align: right;margin-left: -1%;">
                            <span>订单状态: {{getStateName(scope.row.orderStatus)}}</span>
                        </el-col>
                        <el-col :span="6" style="text-align: center;margin-left: 1%;">
                            <span>合计: ¥{{scope.row.actPay}}(含运费：¥{{scope.row.fare}})</span>
                        </el-col>
                        <el-col :span="3">
                            <el-button class="delete-text" type="text" @click="deleteOrder(scope.row.appId)">删除</el-button>
                        </el-col>
                    </el-row>
                    <el-row class="body-row" :gutter="2" type="flex" v-for="(detail,i) in scope.row.details">
                        <el-col :span="12">
                            <div class="tab-sku-col">
                                <div class="sku-img">
                                    <img :src="detail.picUrl" style="width: 100px;height: 100px;object-fit: contain">
                                </div>
                                <div class="sku-attr">
                                    <el-row class="sku-title">{{detail.prodTitle}}</el-row>
                                    <el-row>
                                        <template v-for="(item,index) in detail.properName.split(':')">
                                            <span>{{item}}:{{detail.properVal.split(':')[index]}}</span>
                                        </template>
                                    </el-row>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <span>数量: {{detail.num}}</span>
                        </el-col>
                        <el-col :span="4">
                            <div>小计: ¥{{detail.total}}</div>
                            <div v-if="detail.total != detail.price">(单价: ¥{{detail.price}})</div>
                        </el-col>
                        <el-col :span="4" v-if="i == 0">
                            <div><el-button type="text" size="small" @click="showDetail(scope.row)">查看详情</el-button></div>
                            <div><el-button type="text" size="small" @click="settlement(scope.row)">再次购买</el-button></div>
                        </el-col>
                        <el-col :span="4" v-else></el-col>
                    </el-row>
                </template>
            </el-table-column>
        </el-table>
        <pagination
                v-show="total>0"
                :total="total"
                :page.sync="form.pageNum"
                :limit.sync="form.pageSize"
                @pagination="loadData"
        />
    </div>
</template>

<script>
    import {formatState, formAssemble, Repurchase} from '@/utils/custom'
    import {listOrder} from '@/api/mine/order'
    import {mapGetters} from 'vuex'

    export default {
        name: "cancel",
        props: ["test"],
        data(){
            return{
                total:0,
                tableData:[],
                picUrl:'https://img12.360buyimg.com/n1/s350x449_jfs/t20230/359/1489050457/170171/b018fa50/5b2b6ac6N538fe850.jpg!cc_350x449.jpg',
                form:{},
                ifShowHeader:false,
            }
        },
        methods:{
            loadData(){
                let params =formAssemble(this.test);
                params.orderStatus = '06';
                this.form = params;
                listOrder(params).then((re) => {
                    this.tableData = re.rows;
                    this.total = re.total;
                });
            },
            showDetail(row){
                this.$router.push({path:'/custom/myOrder/detail',query:row})
            },
            getStateName(val){
                return formatState(val);
            },

            //取消/删除订单
            deleteOrder(appId){
                let map = {"appId": appId, "orderStatus": '07'};
                this.$emit('openModal', map);
            },

            /* 再次购买 */
            settlement(order){
                let checkList = Repurchase(order);
                this.$router.push({path:'/order/myOrder/settlement', query:{'checkList': checkList, 'total': order.actPay}});
            },

        },

        created() {
            var that = this;
            that.loadData();
        },

        computed:{
            ...mapGetters(['nginx']),

        },

    }
</script>

<style scoped>

</style>
